module.exports = __webpack_public_path__ + "img/logotipo_green.4b4dd11a.png";